import styled from '@emotion/styled';
import { colors, fonts, layout, radii } from './theme';

const Root = styled.section`
  background: ${colors.baselineBlue};
  padding: clamp(52px, 7vw, 80px) 0;
`;

const Inner = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 32px);
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: space-between;
  align-items: center;
`;

const Copy = styled.div`
  max-width: 560px;
`;

const Eyebrow = styled.p`
  font-family: ${fonts.mono};
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.textMuted};
  margin: 0 0 16px;
`;

const Headline = styled.h2`
  font-family: ${fonts.sans};
  font-size: clamp(32px, 4.2vw, 56px);
  line-height: 1.1;
  letter-spacing: -0.03em;
  max-width: 18ch;
  font-weight: 400;
  color: ${colors.coreBlue};
  margin: 0;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

const buttonBase = `
  box-sizing: border-box;
  font-weight: 500;
  line-height: 1;
  letter-spacing: -0.01em;
  font-size: 18px;
  padding: 13px 24px;
  height: 52px;
  gap: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  white-space: nowrap;
`;

const PrimaryButton = styled.a`
  font-family: ${fonts.sans};
  ${buttonBase}
  color: ${colors.actionPrimaryFg};
  background: ${colors.actionPrimaryBg};
  border: 1px solid transparent;
  border-radius: ${radii.sm};

  &:hover {
    background: ${colors.actionPrimaryBgHover};
  }
`;

const SecondaryButton = styled.a`
  font-family: ${fonts.sans};
  ${buttonBase}
  color: ${colors.coreBlue};
  background: transparent;
  border: 1px solid ${colors.borderDefault};
  border-radius: ${radii.sm};

  &:hover {
    background: rgba(22, 37, 55, 0.06);
  }
`;

export default function CtaSection() {
  return (
    <Root>
      <Inner>
        <Copy>
          <Eyebrow>Get started</Eyebrow>
          <Headline>see the stream running on your inventory</Headline>
        </Copy>
        <Actions>
          <PrimaryButton href="/contact/">Book a demo</PrimaryButton>
          <SecondaryButton href="#contextual-engine">How relevance works</SecondaryButton>
        </Actions>
      </Inner>
    </Root>
  );
}
